exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4{color:#768291;font-size:20px;font-weight:600;margin-bottom:25px}h5{color:#4d4d4d;font-size:18px;font-weight:600}.input-group,.form-group{margin-bottom:40px}.btn-group-1{position:absolute;bottom:30px;right:15px}.accountName,.accountId{padding:13px 0;white-space:nowrap;height:40px;font-weight:400;margin:0;font-size:16px}@media (max-width: 1366px){.accountName,.accountId{font-size:14px;height:38px}}.accountName .copyBtn,.accountId .copyBtn{cursor:pointer}.accountName span,.accountId span{position:relative}.accountName .btn,.accountName a.copyBtn,.accountId .btn,.accountId a.copyBtn{position:absolute;left:100%;top:50%;transform:translateY(-50%);margin-left:15px}.accountName a.copyBtn,.accountId a.copyBtn{font-size:12px;font-weight:600;display:none}.accountName a.copyBtn:hover,.accountName a.copyBtn:focus,.accountId a.copyBtn:hover,.accountId a.copyBtn:focus{text-decoration:none}.accountId:hover a.copyBtn{display:block}.gravatar{border-radius:50%;background-color:#e8eaf1;width:150px;height:150px;margin:40px auto;overflow:hidden}.gravatar img{width:100%;min-height:100%}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/profile/profile.component.scss
// module id = 1353
// module chunks = 4